module.exports = __webpack_public_path__ + "img/alloys.677702c.webp";